import React from 'react';
import Cell from '../Cell';

const CellWithDefault = ({
  renderCondition,
  defaultValue,
  children,
  column,
  row,
  ...props
}) => {
  if (!renderCondition && !defaultValue) return null;

  return (
    <Cell
      {...props}
      column={column}
      row={row}
      placement="body"
      type={!renderCondition && defaultValue ? 'default' : undefined}
    >
      {renderCondition ? children : defaultValue}
    </Cell>
  );
};

export default CellWithDefault;
